import React from "react";
import { useStore } from "../../../../stores/store";

const Point = () => {
  const formElementStyle = "flex items-center my-2";
  const labelElementStyle = "text-md mr-3 w-1/2 flex-1 text-right";
  const inputElementStyle =
    "border border-gray-300 rounded-md p-0.5 w-1/2 text-md";
  const {
    markupPointStyle,
    setMarkupPointStyle,
    markupPointSize,
    setMarkupPointSize,
    markupPointColor,
    setMarkupPointColor,
    markupPointOutlineStyle,
    setMarkupPointOutlineStyle,
    markupPointOutlineWidth,
    setMarkupPointOutlineWidth,
    markupPointOutlineColor,
    setMarkupPointOutlineColor,
  } = useStore();
  return (
    <>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Style:</label>
        <select
          className={inputElementStyle}
          value={markupPointStyle}
          onChange={(e) => setMarkupPointStyle(e.target.value)}
        >
          <option value="circle">Circle</option>
          <option value="square">Square</option>
          <option value="cross">Cross</option>
          <option value="x">X</option>
        </select>
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Size:</label>{" "}
        <input
          type="number"
          className={inputElementStyle}
          value={markupPointSize}
          onChange={(e) => setMarkupPointSize(Number(e.target.value))}
        />
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Color:</label>{" "}
        <input
          value={markupPointColor}
          onChange={(e) => setMarkupPointColor(e.target.value)}
          className={inputElementStyle}
          type="color"
        />
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Outline Style:</label>{" "}
        <select
          className={inputElementStyle}
          value={markupPointOutlineStyle}
          onChange={(e) => setMarkupPointOutlineStyle(e.target.value)}
        >
          <option value="solid">Solid</option>
          <option value="dot">Dotted</option>
          <option value="dash">Dashed</option>
        </select>
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Outline Width:</label>{" "}
        <input
          type="number"
          className={inputElementStyle}
          value={markupPointOutlineWidth}
          onChange={(e) => setMarkupPointOutlineWidth(Number(e.target.value))}
        />
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Outline Color:</label>{" "}
        <input
          className={inputElementStyle}
          type="color"
          value={markupPointOutlineColor}
          onChange={(e) => setMarkupPointOutlineColor(e.target.value)}
        />
      </div>
    </>
  );
};

export default Point;
